import axiosInstance from "../config/axios.config";

export const getBasicDetails = (admissionId) =>
  axiosInstance.get(`/outpatient/admission/${admissionId}/`);

export const getAssignedPackages = (admissionId) =>
  axiosInstance.get(`/outpatient/packages/${admissionId}/`);

export const getSuggestedPackage = (admissionId) =>
  axiosInstance.get(`/careservices/outpatient-packages/${admissionId}/`);

export const getFacilityPackages = (facilityId) =>
  axiosInstance.get(`/careservices/packages/?facility_id=${facilityId}&package_type=OP`);

export const acceptSuggestedPackage = (id, payload) =>
  axiosInstance.patch(`/careservices/assign-op-package/${id}/`, payload);

export const assignOpPackage = (payload) =>
  axiosInstance.post(`/careservices/assign-op-package/`, payload);
